import CryptoJS from "crypto-js";
// import encUtf8 from "crypto-js/enc-utf8";

const AES_KEY = process.env.VUE_APP_AES_KEY;

export const Encrypt = (value, iv) => {
  return CryptoJS.AES.encrypt(value, CryptoJS.enc.Utf8.parse(AES_KEY), {
    mode: CryptoJS.mode.CBC,
    iv: CryptoJS.enc.Utf8.parse(iv),
    padding: CryptoJS.pad.Pkcs7,
  }).toString();
};

// export const Decrypt = (ciphertext) => {
//   const bytes = CryptoJS.AES.decrypt(ciphertext, key, {
//     keySize: 128 / 8,
//     mode: CryptoJS.mode.CBC,
//     iv: iv,
//     padding: CryptoJS.pad.Pkcs7,
//   });
//   const originalText = bytes.toString(encUtf8);
//   console.log(originalText);
// };
